import { DirectiveOptions } from 'vue';
import { EventBus } from '../helpers/bus';

const onTabChanged = ({ tab, container }: { tab: HTMLElement, container: HTMLElement }) => {
    container
        .scrollTo({ left: tab.offsetLeft - 20, top: 0, behavior: 'smooth' });
};

let mouseDownHandler: EventListenerOrEventListenerObject | null = null;

const scrollableTabs: DirectiveOptions = {
    bind(el): void {
        // EventBus.$on('scrollTab', onTabChanged);

        el.querySelectorAll('.nav-tabs-wrapper').forEach(function(navContainer) {
            if (!navContainer) {
                return;
            }

            let pos = { top: 0, left: 0, x: 0, y: 0 };

            const mouseMoveHandler = (e: Event | MouseEvent | any) => {
                if (!navContainer) { return false; }

                // How far the mouse has been moved
                const dx = (e.clientX || 0) - pos.x;
                const dy = (e.clientY || 0) - pos.y;

                // Scroll the element
                navContainer.scrollTop = pos.top - dy;
                navContainer.scrollLeft = pos.left - dx;

                e.stopPropagation();
                e.preventDefault();
                return false;
            };

            const mouseUpHandler = (e: Event) => {
                if (!navContainer) { return false; }

                navContainer.removeEventListener('mousemove', mouseMoveHandler);
                navContainer.removeEventListener('mouseup', mouseUpHandler);

                e.stopPropagation();
                e.preventDefault();
                return false;
            };

            mouseDownHandler = (e: Event | MouseEvent | any) => {
                if (!navContainer) { return false; }

                pos = {
                    // The current scroll
                    left: navContainer.scrollLeft,
                    top: navContainer.scrollTop,
                    // Get the current mouse position
                    x: e.clientX || 0,
                    y: e.clientY || 0,
                };

                navContainer.addEventListener('mousemove', mouseMoveHandler);
                navContainer.addEventListener('mouseup', mouseUpHandler);

                e.stopPropagation();
                e.preventDefault();

                return false;
            };

            navContainer.addEventListener('mousedown', mouseDownHandler);
        });
    },
    unbind() {
        EventBus.$off('scrollTab', onTabChanged);

        document.querySelectorAll('.nav-tabs-wrapper').forEach(function(navContainer) {
            if (!navContainer || !mouseDownHandler) { return; }
            navContainer.removeEventListener('mousedown', mouseDownHandler);
        });
    },
};

export default scrollableTabs;
